import { getCampaigns } from '../../application/pageDataObject'
import { warn } from '../../application/console'
import { classList, node } from '../../utils/dom'
import { getCountryCode } from '../../providers/geolocationProvider'
import { isCampaignEnabled } from '../../config/campaignConfig'
import { normalizeCountryCode } from '../../utils/campaign'

const SKINS_CAMPAIGN_TYPE = 'skins'
const SKINS_DOM_CLASS = 'skinned'
const SKINS_RAILS_ELEMENT_NAMES = ['start', 'end'].reduce(function(acc, side) {
  acc[side] = `.site-header__header-rail--${side}`
  return acc
}, {})

function getActiveCampaigns() {
  if (!getCampaigns() || !getCampaigns().skins) {
    return Promise.resolve([])
  }
  const skinsCampaigns = getCampaigns().skins.filter(c => c.campaignType === SKINS_CAMPAIGN_TYPE)
  const isEnabledPromises = skinsCampaigns.map(isCampaignEnabled)
  return Promise.all(isEnabledPromises).then(function handleEnabledPromisesResult(
    enabledPromisesResult
  ) {
    const activeCampaigns = enabledPromisesResult.filter(isCampaignEnabled).map(c => c.campaign)
    return activeCampaigns
  })
}

function handleSkinsErrors(e) {
  warn('skin campaig campaignn error', e)
}

function addCampaignClassesToBody() {
  classList(document.body).add(SKINS_DOM_CLASS)
}

function applySkinsImages({ start, end }) {
  const startElement = node(SKINS_RAILS_ELEMENT_NAMES.start)
  const endElement = node(SKINS_RAILS_ELEMENT_NAMES.end)
  startElement.style.backgroundImage = `url('${start}')`
  endElement.style.backgroundImage = `url('${end}')`
}

function getSkinImagesByConfig(config) {
  return getCountryCode()
    .then(normalizeCountryCode)
    .then(function handleSkinImagesByCountryCode(countryCode) {
      const { countryCodesToImages } = config
      const imageGroup = countryCodesToImages.find(group => {
        const countryCodes = group.countryCodes.map(normalizeCountryCode)
        return countryCodes.includes(countryCode)
      })
      if (imageGroup) {
        return Promise.resolve(imageGroup.images)
      }
      return Promise.reject(`cannot find skins images for country code ${countryCode}`)
    })
}

function runSkinCampaign(config) {
  getSkinImagesByConfig(config)
    .then(applySkinsImages)
    .then(addCampaignClassesToBody)
    .catch(handleSkinsErrors)
}

export default function initSkinCampaign() {
  getActiveCampaigns()
    .then(function handleActiveCampaigns(activeCampaigns) {
      const numCampaigns = activeCampaigns.length
      if (numCampaigns > 1) {
        warn('cannot run multiple skins campaigns! please fix the config')
        return
      }
      if (numCampaigns === 0) {
        return
      }
      const campaignToRun = activeCampaigns[0]
      runSkinCampaign(campaignToRun)
    })
    .catch(handleSkinsErrors)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/skinsInitializer.js